import type { Option } from 'ui-component-library/components/00-Primitives/Inputs/Dropdown'
import SortIcon from 'ui-component-library/icons/sort.svg'
import FilterDropdown from '../FilterDropdown'

type Props = {
  onChange: (sort: 'DESC' | 'ASC') => void
  labelText: string
  options: Option[]
  selectedOption: string
}

function SortDropdown({ onChange, labelText, options, selectedOption }: Props) {
  function handleChange(value: string) {
    if (value === 'DESC' || value === 'ASC') {
      onChange(value)
    }
  }

  return (
    <FilterDropdown
      onChange={handleChange}
      Icon={SortIcon}
      labelText={labelText}
      options={options}
      selectedOption={selectedOption}
    />
  )
}

export default SortDropdown
